import {
  BookmarkFilledIcon,
  TextButton,
  theme,
} from '@maersktankersdigital/web-components'
import { Box, Typography } from '@mui/material'
import styled from 'styled-components/macro'
import { COLORS } from '~theme/colors'
import { Z_INDEX } from '~types/z-index'

export const DocumentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${theme.SPACINGS[3]};
  background-color: ${COLORS.greys.ultraLight};
  gap: ${theme.SPACINGS[2]};

  @media only screen and (${theme.BREAKPOINTS.sm}) {
    flex-direction: row;
    justify-content: space-between;
    gap: 0;
  }
`

export const DocumentInfo = ({
  publishDate,
  title,
  category,
}: {
  publishDate: string
  title: string
  category: string
}) => {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: theme.SPACINGS[1] }}
    >
      <Typography variant="menu" color={COLORS.greys.dark}>
        {publishDate} | {category}
      </Typography>
      <Typography variant="paragraph1" sx={{ lineBreak: 'anywhere' }}>
        {title}
      </Typography>
    </Box>
  )
}

export const DocumentsWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'reverse-column', lg: 'row' },
      gap: theme.SPACINGS[1],
    }}
  >
    {children}
  </Box>
)

export const DocumentButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.SPACINGS[1]};

  & svg {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  @media only screen and (${theme.BREAKPOINTS.sm}) {
    justify-content: initial;
  }
`

export const FileIconWrapper = styled.div`
  width: 2.5em;
  height: 2.5em;
  background-color: ${COLORS.primary.white};
  display: grid;
  place-content: center;

  & svg {
    width: 17px;
    height: 22px;
  }
`

export const ContentWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: theme.SPACINGS[3],
        alignItems: 'flex-start',
      }}
    >
      {children}
    </Box>
  )
}

export const FilterWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: theme.SPACINGS[1],
        whitespace: { xs: 'nowrap', md: 'normal' },
      }}
    >
      {children}
    </Box>
  )
}

export const FiltersWrapper = styled.div`
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  display: block;
  min-width: 30%;
`

export const FiltersInnerWrapper = styled.div<{ $isFiltersOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${theme.SPACINGS[3]};
  padding: ${theme.SPACINGS[3]} ${theme.SPACINGS[4]};
  background-color: ${COLORS.secondary.blueTint};
  height: fit-content;
`

export const DocumentSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${COLORS.greys.light};

  @media only screen and (${theme.BREAKPOINTS.sm}) {
    display: none;
  }
`

export const StyledTextButton = styled(TextButton)`
  color: ${COLORS.primary.maerskBlue};

  & svg path {
    fill: ${COLORS.primary.maerskBlue};
  }
`

export const CheckboxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.SPACINGS[2]};
`

export const StyledFilterButton = styled(TextButton)`
  align-self: flex-end;
  font-size: 14px;
  z-index: ${Z_INDEX.MainNavUserMenu};
`

export const StyledBookmarkFilledIcon = styled(BookmarkFilledIcon)`
  color: ${COLORS.primary.maerskBlue};
`

export const BookmarkWrapper = styled.div`
  color: ${COLORS.greys.dark};
`
